/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Button from '../elements/Button';

// App categories to showcase the breadth of the ecosystem
const appCategories = [
  {
    category: 'AI & Machine Learning',
    apps: [
      { name: 'AI Art Generator', downloads: '2M+', rating: '4.8' },
      { name: 'ChatGenius', downloads: '1.5M+', rating: '4.7' },
      { name: 'VoiceAI', downloads: '800K+', rating: '4.6' },
    ],
    icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    color: 'from-purple-500 to-indigo-600',
  },
  {
    category: 'Productivity',
    apps: [
      { name: 'TaskFlow Pro', downloads: '1.2M+', rating: '4.9' },
      { name: 'NoteGenius', downloads: '900K+', rating: '4.7' },
      { name: 'FocusTimer', downloads: '600K+', rating: '4.8' },
    ],
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    color: 'from-blue-500 to-cyan-600',
  },
  {
    category: 'Health & Wellness',
    apps: [
      { name: 'MindfulMe', downloads: '1.8M+', rating: '4.8' },
      { name: 'FitTrack AI', downloads: '1.1M+', rating: '4.6' },
      { name: 'SleepWell', downloads: '750K+', rating: '4.7' },
    ],
    icon: 'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z',
    color: 'from-pink-500 to-rose-600',
  },
  {
    category: 'Entertainment',
    apps: [
      { name: 'StreamHub', downloads: '3M+', rating: '4.9' },
      { name: 'GameZone', downloads: '2.2M+', rating: '4.7' },
      { name: 'MusicMix AI', downloads: '1.4M+', rating: '4.8' },
    ],
    icon: 'M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    color: 'from-orange-500 to-amber-600',
  },
];

export default function FeaturedApps() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-16">
            <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-3">
              Our App Ecosystem
            </p>
            <h2 className="text-4xl md:text-5xl text-theme-blue font-bold mb-4">
              50+ Apps Across Multiple Categories
            </h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              From AI-powered tools to entertainment apps, we build products
              that millions love and use daily.
            </p>
          </div>
        </Fade>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {appCategories.map((category, index) => (
            <Fade key={category.category} direction="up" delay={index * 100} triggerOnce>
              <div className="group bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-xl hover:border-theme-purple/30 transition-all duration-300 cursor-pointer">
                {/* Category Icon */}
                <div
                  className={`w-14 h-14 rounded-xl bg-gradient-to-br ${category.color}
                    flex items-center justify-center mb-5 group-hover:scale-110
                    transition-transform duration-300`}
                >
                  <svg
                    className="w-7 h-7 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={category.icon} />
                  </svg>
                </div>

                {/* Category Name */}
                <h3 className="text-xl font-semibold text-theme-blue mb-4">{category.category}</h3>

                {/* Apps List */}
                <div className="space-y-3">
                  {category.apps.map((app) => (
                    <div key={app.name} className="flex items-center justify-between">
                      <span className="text-gray-600 text-sm">{app.name}</span>
                      <div className="flex items-center gap-2">
                        <span className="text-xs text-gray-400">{app.downloads}</span>
                        <div className="flex items-center">
                          <svg className="w-3 h-3 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                          <span className="text-xs text-gray-500 ml-0.5">{app.rating}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* View More */}
                <div className="mt-5 pt-4 border-t border-gray-100">
                  <span className="text-sm font-medium text-theme-purple group-hover:text-dark-theme-purple transition-colors">
                    View all apps
                    <svg className="w-4 h-4 inline ml-1 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </span>
                </div>
              </div>
            </Fade>
          ))}
        </div>

        {/* Bottom CTA */}
        <Fade direction="up" delay={400} triggerOnce>
          <div className="text-center mt-12">
            <Button
              href="/project"
              type="link"
              className="inline-flex items-center px-8 py-4 text-theme-purple font-medium border-2 border-theme-purple rounded-xl hover:bg-theme-purple hover:text-white transition-all duration-300 cursor-pointer"
            >
              Explore All 50+ Apps
              <svg className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Button>
          </div>
        </Fade>
      </div>
    </section>
  );
}
